import React, { useState, useEffect } from 'react';
import '../styles/WordCounter.css';

const WordCounter: React.FC = () => {
  const [text, setText] = useState('');
  
  // Initialize AdSense
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  const wordCount = text.trim().split(/\s+/).filter(word => word).length;
  const charCount = text.length;

  return (
    <div className="word-counter">
      <h2>Contador de Palavras e Caracteres</h2>
      <textarea
        value={text}
        onChange={handleChange}
        rows={10}
        className="w-full p-2 border"
        placeholder="Digite ou cole seu texto aqui..."
      />
      <div className="stats-container">
        <div className="stat">
          <div className="stat-value">{wordCount}</div>
          <div className="stat-label">Palavras</div>
        </div>
        <div className="stat">
          <div className="stat-value">{charCount}</div>
          <div className="stat-label">Caracteres</div>
        </div>
      </div>
      
      {/* Google AdSense */}
      <div className="ad-container">
        <ins className="adsbygoogle"
             style={{ display: 'block' }}
             data-ad-client="ca-pub-1989683361613000"
             data-ad-slot="1234567890"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>
      </div>
    </div>
  );
};

export default WordCounter; 